import angular from 'angular';
import '../controllers/modals/group';
import '../services/group';
import '../services/notifications';
import { get } from 'lodash';
import '../services/line-flow-type-organization';

const module = angular.module('whyline.controllers.groups', [
  'whyline.modals.group',
  'whyline.services.group',
  'whyline.services.notifications',
]);

const GroupsController = ($scope, $state, $uibModal, currentPlace, $translate, NotificationService, GroupService, SlaService, LineFlowTypeOrganizationService) => {
  $scope.placeId = $state.params.placeId ? $state.params.placeId : false;
  $scope.organizationId = $state.params.organizationId ? $state.params.organizationId : false;
  GroupService.GetAllGroups().then(combinedGroups => {
    /**
     * Nota: estos groups no son ni el modelo GroupModel, ni el modelo OrganizationGroupModel,
     * es un merge hecho por el back que contiene el resultado de combinar ambos al mismo tiempo que agrega las filas.
     * Incluyen un atributo group que contiene el GroupModel asociado al place actual.
     * Por eso voy a llamarlos CombinedGroup.
     */
    $scope.combinedGroups = combinedGroups;
  });

  LineFlowTypeOrganizationService.GetAllEnabledByOrganization(
    currentPlace.organizationId,
    false,
  ).then((lftoList) => {
    $scope.lineFlowTypeOrganizations = lftoList;
  });

  // Modal
  $scope.open = combinedGroup => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/group.html',
      size: 'md',
      controller: 'GroupModalController',
      resolve: {
        combinedGroup: () => combinedGroup,
        organizationId: () => $scope.organizationId,
      },
    }).result.then(() => {
      GroupService.GetAllGroups().then(combinedGroups => {
        $scope.combinedGroups = combinedGroups;
      });
    });
  };

  SlaService.GetSlaById(currentPlace.configuration.agingSLA._id).then(sla => {
    $scope.sla = sla;
  });

  $scope.openSlaModal = (slaId) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/slas-modal.html',
      size: 'lg',
      controller: 'SlaModalController',
      resolve: {
        slaId: () => slaId,
      },
    });
  };

  $scope.getLineFlowTypeName = (lineFlowTypeId) => {
    if ($scope.lineFlowTypeOrganizations) {
      const lineFlowType = $scope.lineFlowTypeOrganizations.find(
        (lineFlowTypeOrganization) => lineFlowTypeOrganization._id.toString() === lineFlowTypeId,
      );
      return get(lineFlowType, 'name', '') || '';
    }
  };

  $scope.openLineFlowType = (lineFlowTypeOrganizationId) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/line-flow-type-view-modal.html',
      size: 'lg',
      controller: 'LineFlowTypeViewModalController',
      resolve: {
        lineFlowTypeOrganizationId: () => lineFlowTypeOrganizationId,
      },
    });
  };
};

module.exports = module.controller('GroupsController', GroupsController);
